import React from 'react';
import styles from '../../assets/homeStats.module.css';
import { Link } from 'react-router-dom';

const HomeStats = ({ topUsers }) => {

    const StatDiv=({solvedProblems,totalProblems})=>{
        const angle=((solvedProblems/totalProblems)*100)
        const mapping={
            '--p': angle,
            '--b': "4px",
            '--c': '#ffa116',
        }
        return(
        <div className={styles.pie} style={mapping}>{solvedProblems}</div>)
    }

   return (
    <div className={styles.maindiv}>
        <div className='d-flex align-items-center justify-content-between'>
        <h1 className={styles.heading}>Top Weekly Coders</h1></div>
        <div className='p-1'>
        <table>
          <thead>
            <tr className="d-none d-md-table-row">
          <th>User</th>
          <th>Solved</th>
        </tr>
      </thead>
      <tbody>
        {
        Object.keys(topUsers).map((username,index)=>{
            return(
            <tr className={styles.tableRow}  key={index}>
            <td className={`${styles.cell} ${styles.cellname}`}><Link to={`/profile/${username}`} className={`${styles.cell} ${styles.cellname}`}>{username}</Link></td>
            <td className={styles.cell}>{topUsers[username]}</td>
          </tr>
            )
         })
         }
      </tbody>
        </table>
        </div>

        {/* <div className='d-flex align-items-center justify-content-between'>
            <h2 className={styles.title}>Leetcode</h2>
            <StatDiv solvedProblems={counts.Lc} totalProblems={2700}/>
        </div>
        <div className='d-flex align-items-center justify-content-between'>
            <h2 className={styles.title}>Codeforces</h2>
            <StatDiv solvedProblems={counts.Cf}  totalProblems={8000}/>
        </div>
        <div className='d-flex align-items-center justify-content-between'>
            <h2 className={styles.title}>Atcoder</h2>
            <StatDiv solvedProblems={counts.At}  totalProblems={3000}/>
        </div> */}
    </div>
   )
  };

export default HomeStats;
